import { Licence } from './../../../supplier/models/Licence';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Supplier } from '../../../supplier/models/Supplier';
import { AnreService } from '../../service/anre.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-suppliers-licence',
  templateUrl: './suppliers-licence.component.html',
  styleUrls: ['./suppliers-licence.component.scss']
})
export class SuppliersLicenceComponent implements OnInit {
  public supplier: Supplier;
  public suppliersLicenceForm: FormGroup;
  public cui = 'CUI';
  public supplierName = 'Denumire furnizor';
  public decision = 'Decizie';
  public markAs = 'Marchează ca:';
  public saveButtonText = 'Salvează';
  public licenceStatus: number;
  public shouldLiftLicenceRestriction = false;
  public licence: Licence;
  public licenceCode: string;
  public actionType: string;
  public tomorrow: Date;
  public isGas: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private anreService: AnreService,
    private router: Router
  ) {
    this.tomorrow = new Date();
    this.tomorrow.setDate(this.tomorrow.getDate() + 1);
    this.supplier = JSON.parse(localStorage.getItem('supplier'));
    this.licence = JSON.parse(localStorage.getItem('licence'));
    this.isGas = !!JSON.parse(localStorage.getItem('isGas'));
    this.actionType = localStorage.getItem('actionType');
    if (!this.licence) {
      this.licence = {} as Licence;
    }
    if (this.actionType === 'editeazaLicenta') {
      this.shouldLiftLicenceRestriction = true;
    } else if (this.actionType === 'retrageLicenta') {
      this.licence.status = 'ANULAT';
    } else if (this.actionType === 'ridicaSuspendare') {
      this.licence.status = 'ACTIV';
      // this.shouldLiftLicenceRestriction = true;
    }

    if (this.supplier == null || this.licence == null) {
      this.router.navigateByUrl('/anre/furnizori');
    } else {
      this.initSupplierLicenceForm();
    }
  }

  initSupplierLicenceForm(): void {
    console.log('this.licence2', this.licence);
    this.suppliersLicenceForm = this.formBuilder.group({
      cui: new FormControl({ value: this.supplier.code, disabled: true }),
      supplierName: new FormControl({ value: this.supplier.name, disabled: true }),
      supplierType: new FormControl(''),
      statusChangeDate: new FormControl(this.licence.statusChangeDate),
      licenceStatus: new FormControl({ value: this.licence.status, disabled: (this.actionType === 'editeazaLicenta' || this.actionType === 'retrageLicenta') }),
      licenceType: new FormControl(this.licence.type),
      reason: new FormControl(this.licence.statusChangeReason)
    });
  }

  ngOnInit(): void {
    // this.initSupplierLicenceForm();
  }

  setActive(): void {
    this.shouldLiftLicenceRestriction = !this.shouldLiftLicenceRestriction;
  }

  onSubmit(): void {
    if (!this.suppliersLicenceForm.valid) {
      Swal.fire({
        html: `Va rugam sa completati toate campurile`,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        customClass: {
          popup: 'popup-z-elevate-24-blue'
        }
      });
      return;
    }

    const licence: Licence = {
      id: this.licence.id,
      series: this.isGas ? this.supplier.gasSeries : this.supplier.electricitySeries,
      status: this.suppliersLicenceForm.get('licenceStatus').value,
      statusChangeReason: this.suppliersLicenceForm.get('reason').value,
      statusChangeDate: this.suppliersLicenceForm.get('statusChangeDate').value
    } as Licence;
    this.anreService.changeLicenceStatus(licence).subscribe(e => {
      return this.router.navigateByUrl('/anre/furnizori');
    });
    // if (licence.status === 'ACTIVE') {
    //   if (window.confirm('Sigur doriti suspendarea licentei acestui furnizor?')) {
    //     licence.status = this.suppliersLicenceForm.get('licenceStatus').value;
    //     licence.statusChangeReason = this.suppliersLicenceForm.get('reason').value;

    //     this.anreService.changeLicenceStatus(licence).subscribe(e => {
    //       return this.router.navigateByUrl('/anre/furnizori');
    //     });
    //   }
    // } else if (this.shouldLiftLicenceRestriction === true) {
    //   licence.status = 'ACTIVE';
    //   licence.statusChangeReason = this.suppliersLicenceForm.get('reason').value;

    //   if (window.confirm('Sigur doriti reactivarea licentei acestui furnizor?')) {
    //     this.anreService.changeLicenceStatus(licence).subscribe(e => {
    //       return this.router.navigateByUrl('/anre/furnizori');
    //     });
    //   }
    // }
  }

  onCancel(): void {
    history.back();
  }

  clean(): void {
    localStorage.removeItem('licence');
    localStorage.removeItem('supplier');
    localStorage.removeItem('actionType');
  }


}
